<div class="py-8">
  <!-- Header with form -->
  <div>
    <h1 class="text-3xl font-semibold md:text-2xl">{{ 'codes.title' | transloco }}</h1>

    <div class="mt-6 flex flex-col justify-between gap-8 md:flex-row md:gap-4 lg:mt-4">
      <p>{{ 'codes.subTitle' | transloco }}</p>
      <form class="flex flex-col gap-2 md:flex-row md:items-stretch md:gap-3 md:gap-4" (submit)="createCode($event)">
        <input
          #newDeviceInput
          type="text"
          class="border-surface-300 bg-surface-0 placeholder:text-surface-500 min-w-[200px] flex-1 rounded-md border px-4 py-3 text-base focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500 max-md:w-full md:w-full lg:min-w-[260px]"
          [(ngModel)]="codeNote"
          name="codeNote"
          [placeholder]="'codes.inputHint' | transloco"
          data-testid="create-code-input" />
        <p-button
          type="submit"
          [label]="'codes.createButtonText' | transloco"
          class="whitespace-nowrap"
          styleClass="md:h-full w-full"
          data-testid="create-code-button"></p-button>
      </form>
    </div>
  </div>

  <div class="mt-10 min-h-[200px] overflow-hidden">
    <app-device-codes-list
      [codes]="paginatedCodes()"
      [highlightedCodeId]="highlightedCodeId()"
      (copyCodeToClipboard)="copyCodeToClipboard($event)"
      (handleCodeAction)="handleCodeAction($event)"></app-device-codes-list>
  </div>

  <!-- Pagination -->
  @if (allCodes().length > 0) {
    <div class="mt-6 flex flex-col items-center justify-between gap-4 px-2 md:flex-row">
      <div class="text-sm text-slate-700">{{ pageInfo() }}</div>
      <div class="flex gap-2">
        <p-button icon="pi pi-chevron-left" [disabled]="!canGoPrevious()" (click)="previousPage()" severity="secondary" [outlined]="true"></p-button>
        <p-button icon="pi pi-chevron-right" [disabled]="!canGoNext()" (click)="nextPage()" severity="secondary" [outlined]="true"></p-button>
      </div>
    </div>
  }
</div>
